<div class="calculator-container">
  <app-header site=state.site/>
  <div class="scrollable-content">
    <app-calculate-action
      site=state.site
      amount=state.amount
      currency=state.currency
      onCalculate("updateCreditOffers")
    />
    <div class="calc_mainContent">
      <div class="calculatorTable">
        <app-table
          site=state.site
          error=state.error
          installmentOffers=state.installmentOffers
          loading=state.loading
        />
      </div>
      <app-footer site=state.site/>
    </div>
  </div>
  <input type="hidden" id="enableApply" value=input.enableApply>
  <input type="hidden" id="deviceName" value=(input.deviceDetails.deviceName)>
</div>
